module.exports = __webpack_public_path__ + "img/mergdata_digi_variation_2.77d1ea52.png";